import Vue from '@/app'
import axios from 'axios'
import discountType from '@/helpers/discountTypes'
import units from '@/helpers/units'
import roles from "@/helpers/users/roles"
import status from "@/helpers/users/status"
import projectStatus from "@/helpers/projectStatus"

export default {
    prepareMaterials({commit, state}, force = false) {
        return new Promise((resolve, reject) => {
            if (state.materials.loaded && !force) {
                resolve()
            } else {
                axios.all([
                    Vue.$http.get('planks', {params: {system: state.system}}),
                    Vue.$http.get('surfaces'),
                    Vue.$http.get('joists'),
                    Vue.$http.get('items'),
                    Vue.$http.get('slats'),
                    Vue.$http.get('additionals'),
                    Vue.$http.get('stair'),
                    Vue.$http.get('elevation'),
                    Vue.$http.get('allslats'),
                    Vue.$http.get('corner'),
                    Vue.$http.get('systems')

                ])
                    .then(axios.spread((planks, surfaces, joists, items, slats, additionals, stair, elevation, allslats, corner, systems) => {
                        commit('setAvailableMaterials', {
                            planks: planks.data,
                            surfaces: surfaces.data,
                            joists: joists.data,
                            slats: slats.data,
                            additionals: additionals.data,
                            stair: stair.data,
                            elevation: elevation.data,
                            allslats: allslats.data,
                            corner: corner.data,
                            systems: systems.data
                        })
                        commit('setItems', items.data)
                        if (state.configurator.surfaces.length === 0) {
                            commit('appendSurface')
                        }
                        resolve()
                    }))
                    .catch(() => {
                        reject()
                    })
            }
        })
    },
    prepareManualMaterials({commit, state}, force = false) {
        return new Promise((resolve, reject) => {
            if (state.materials.loaded && !force) {
                resolve()
            } else {
                axios.all([
                    Vue.$http.get('planks'),
                    Vue.$http.get('surfaces'),
                    Vue.$http.get('joists'),
                    Vue.$http.get('items'),
                    Vue.$http.get('slats'),
                    Vue.$http.get('stair'),
                    Vue.$http.get('additionals')
                ])
                    .then(axios.spread((planks, surfaces, joists, items, slats, stair, additionals) => {
                        commit('setAvailableManualMaterials', {
                            planks: planks.data,
                            surfaces: surfaces.data,
                            joists: joists.data,
                            slats: slats.data,
                            stair: stair.data,
                            additionals: additionals.data,
                        })
                        commit('setItems', items.data)
                        resolve()
                    }))
                    .catch(() => {
                        reject()
                    })
            }
        })
    },
    setUpFirmao({commit}) {
        return new Promise((resolve, reject) => {
            Vue.$http.get('firmao')
                .then(({data}) => {
                    commit('setUpFirmao', data)
                    resolve()
                })
                .catch(() => {
                    reject()
                })
        })
    },
    prepareOffer({commit, state}) {
        return new Promise((resolve, reject) => {
            Vue.$http.get('orders/prepare', { params:
                    {
                        terraces: state.configurator.surfaces.map(surface => surface.id),
                        currency_id: state.configurator.defaultCurrency.id
                    }

                })
                .then(({data}) => {
                    commit('setOfferItems', data.map(item => {
                        item.discountType = discountType[0]
                        item.unit = units.find(unit => unit.id === item.unit)
                        return item
                    }))
                    resolve()
                })
                .catch(() => {
                    reject()
                })
        })
    },
    loadUsers({commit, state}, force = false) {
        return new Promise((resolve, reject) => {
            if (state.users.length > 0 && !force) {
                resolve()
            } else {
                Vue.$http.get('users')
                    .then(({data}) => {
                        commit('setUsers', data.users.map(user => {
                            user.role_value = user.role
                            user.role = roles.translate(user.role)
                            user.statusLabel = status.translate(user.status)
                            return user
                        }))
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }
        })
    },
    loadMyCompany({commit}) {
        return new Promise((resolve, reject) => {
            Vue.$http.get('company')
                .then(({ data }) => {
                    commit('updateMyCompany', data)
                    resolve()
                })
                .catch(() => {
                    reject()
                })
        })
    },
    requestProjects({commit, state}) {
        commit('projectStatus', projectStatus.pending)
        commit('clearProjects')
        Vue.$http.post('terrace/projects', state.configurator.surfaces.map(surface => surface.id))
            .then(({ data }) => {
                commit('assignProjects', data)
                commit('projectStatus', projectStatus.loaded)
            })
            .catch(() => {
                commit('projectStatus', projectStatus.unavailable)
            })
    },
    setAvailableMaterialsForPlank({commit},value){
        axios.all([
            Vue.$http.post('plankslats', {id: value}),
            Vue.$http.post('plankjoists', {id: value}),
            Vue.$http.post('planksurfaces', {id: value})
        ])
        .then(axios.spread((plankslats,plankjoists, planksurfaces) => {
            commit("setAvailableSlats", { slats: plankslats.data });
            commit("setAvailableJoists", { joists: plankjoists.data });
            commit("setAvailableSurfaces", { surfaces: planksurfaces.data });
        }))
        .catch((error) => {
            console.log(error.message)
        })

    },
    setActualCurrencies({commit, state}){
        Vue.$http.get('/currency')
                    .then((response) => {
                        commit('setCurrencies', response.data )
                        let locale = Vue.$cookies.get("locale");

                        if(locale){
                            commit('setDefaultCurrency', locale)
                        }else{
                            commit('setDefaultCurrency', state.locale)
                        }
                    })
                    .catch(() => {

                    })
    }
}
